import { defineStore } from "pinia";
import { ref } from "vue";
import { INSPECTION_LINKS_ENDPOINT } from "@/constants/Endpoints";
import axios from "axios";
import { LOGGER } from "@/util/logger";
import { clone } from "@/util/clone";
import { MODULE_TYPES } from "@/constants/InspectionConstants";

export const useElementsStore = defineStore("elements", () => {
  //elements data is loaded either from idb (pouch db for inspection module) or service (for management module)
  let elementsData = ref({});

  const loadElementsObject = async (moduleType, quickSearchData, structure) => {
    if (moduleType === MODULE_TYPES.INSPECTION) {
      //if moduleType is inspection, load data from pouchDB
      convertToInspModuleObject(structure);
    } else if (moduleType === MODULE_TYPES.MANAGEMENT) {
      //if moduleType is management, load data from service call
      await getInspLinkElements(quickSearchData);
    }
  };

  const getElementsObject = () => {
    return clone(elementsData.value);
  };

  const saveElements = async (moduleType, elementsValue, structure, quickSearchData) => {
    let isSuccess = false;
    if (moduleType === MODULE_TYPES.INSPECTION) {
      convertToSaveInspModuleObject(elementsValue, structure);
      isSuccess = true;
    } else if (moduleType === MODULE_TYPES.MANAGEMENT) {
      isSuccess = await updateElements(convertToSaveInspLinkObject(elementsValue), quickSearchData);
    }
    return isSuccess;
  };

  const updateElements = async (elements, quickSearchData) => {
    let isSuccess = true;
    const url = INSPECTION_LINKS_ENDPOINT.UPDATE_ELEMENTS;
    await axios
      .put(url, elements)
      .then((response) => {
        LOGGER.logEvent(LOGGER.EventAction.Update, LOGGER.EventCat.RequestResponse, "Update Elements", response);
        convertToInspLinkObject(response.data.data, quickSearchData);
      })
      .catch((e) => {
        LOGGER.logException(e);
        isSuccess = false;
      });
    return isSuccess;
  };

  const convertToSaveInspModuleObject = (elementsValue, structure) => {
    structure.inspectionElementPons = elementsValue.inspectionElementPons?.filter((f) => !f.deleted);
    structure.structureUnits = elementsValue.structureUnits;
  };

  const convertToInspModuleObject = (elements) => {
    elementsData.value = elements;
  };

  const getInspLinkElements = async (quickSearchData) => {
    //clear idb object
    elementsData.value = {};
    const { BRKEY, INSPECTIONID } = quickSearchData;
    let url = INSPECTION_LINKS_ENDPOINT.GET_ELEMENTS.replace("{brkey}", BRKEY).replace("{inspectionId}", INSPECTIONID);

    await axios
      .get(url)
      .then((resp) => {
        convertToInspLinkObject(resp.data.data, quickSearchData);
      })
      .catch((e) => {
        LOGGER.logException(e);
      });
  };

  const convertToSaveInspLinkObject = (elements) => {
    return {
      brkey: elements.structureBridge.brkey,
      inspectionId: elements.inspection.inspectionId,
      structureUnits: elements.structureUnits,
      inspectionElementPons: elements.inspectionElementPons,
    };
  };

  const convertToInspLinkObject = (elements, quickSearchData) => {
    const { BRKEY, INSPECTIONID, SERVTYPON } = quickSearchData;
    elementsData.value = {};
    const obj = {
      structureBridge: { brkey: BRKEY, servTypOn: SERVTYPON },
      inspection: { inspectionId: INSPECTIONID },
      structureUnits: elements?.structureUnits,
      inspectionElementPons: elements?.inspectionElementPons,
    };

    elementsData.value = obj;
  };

  return {
    elementsData,
    getElementsObject,
    saveElements,
    loadElementsObject,
  };
});
